// src/pages/Stub.jsx — placeholder for pages not yet built in React
// These redirect to the Flask vanilla JS version

import { useEffect } from 'react';

export function FlaskRedirect({ to }) {
  useEffect(() => { window.location.href = to; }, [to]);
  return <p style={{ padding: 24, color: 'var(--fg2)' }}>Redirecting…</p>;
}

export function NotFound() {
  return (
    <div style={{ padding: 40, textAlign: 'center' }}>
      <div style={{ fontSize: 64, fontWeight: 900, color: 'var(--accent)' }}>404</div>
      <div style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 8 }}>Page Not Found</div>
      <a href="/" style={{ color: 'var(--accent)' }}>← Back to Home</a>
    </div>
  );
}
